
<div class="agpr-brandTopics">
    <div class="agpr-brandTopics-header">
        <label class="agpr-brandTopics-header-label">
            {{ 'Common.brandInformation.topics.label' | localize }}
        </label>
    </div>
    <div class="agpr-brandTopics-field">
        <div class="agpr-brandTopics-autocompleteWrapper">
            <agpr-autocomplete
                [id]="id + '_autocomplete'"
                class="agpr-brandTopics-autocomplete"
                panelStyleClass="agpr-brandTopics-overlayPanel"
                [ariaLabelledBy]="id + 'header_label'"
                [placeholder]="'Common.brandInformation.topics.placeholder'"
                [suggestions]="suggestions$"
                [dropdown]="true"
                [showHiddenOption]="showHiddenOption"
                labelField="label"
                (itemSelected)="selectTopic($event)"
                [disabled]="disabled"
            ></agpr-autocomplete>
        </div>
        <div class="agpr-brandTopics-chipsWrapper">
            @if(topicChips.length) {
                <ul
                    [id]="id + '_chipList'"
                    class="agpr-brandTopics-list"
                    agprListKeyboardNavigation
                    [list]="topicChips"
                    [focusOnChild]="true"
                >
                    @for (chip of topicChips; track chip.topicId; let i = $index) {
                        <li
                            [id]="id + '_chip_' + i"
                            class="agpr-brandTopics-listItem"
                            [attr.aria-label]="chip.label"
                        >
                            <div class="agpr-chip">
                                <a
                                    [id]="id + '_chipLink_' + i"
                                    class="agpr-chip-label"
                                    target="_blank"
                                    [routerLink]="['Monitoring', 'topics', 'topic', chip.topicId]"
                                >
                                    {{  chip.label }}
                                </a>
                                <agpr-button
                                    [id]="id + '_chip_' + i + '_delete'"
                                    class="agpr-chip-button"
                                    [style]="buttonTypes.icon"
                                    [icon]="'fa-regular fa-duotone fa-xmark'"
                                    tooltip="Common.forms.chips.delete"
                                    [tooltipPosition]="'top'"
                                    (click)="removeChip(chip)"
                                    [disabled]="disabled"
                                ></agpr-button>
                            </div>
                            @let favoriteClass = 'agpr-brandTopics-' + (chip.favorite ? 'icon' : 'button');
                            @let favoriteTooltip = chip.favorite ? 'Common.brandInformation.topics.preferred' : 'Common.brandInformation.topics.setPreferred';
                            @let favoriteIcon = chip.favorite ? 'fa-solid fa-star' : 'fa-regular fa-duotone fa-star';
                            <agpr-button
                                [id]="id + '_setPreferredColor_' + i"
                                [class]="favoriteClass"
                                [style]="buttonTypes.icon"
                                [icon]="favoriteIcon"
                                [tooltip]="favoriteTooltip"
                                [tooltipPosition]="'top'"
                                (click)="setFavorite(chip)"
                                [disabled]="disabled"
                            ></agpr-button>
                        </li>
                    }
                </ul>
            }
        </div>
    </div>
</div>



